module.exports = __webpack_public_path__ + "static/media/AP.32c5f04c.jpg";